import React from "react";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";
import clsx from "clsx";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import EditDialog from "@vocollege/components/dist/EditDialog";
import { CourseMomentProps } from "./global";
import { useStyles } from "./styles";
import { getUserString } from "@vocollege/app/dist/modules/VoHelpers";

const CourseMoment: React.FC<CourseMomentProps> = (props) => {
  const { item, ...rest } = props;
  const classes = useStyles();

  if (!item) {
    return <></>;
  }

  return (
    <EditDialog {...rest}>
      <div className={classes.root}>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.form.labels.items}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.items}</Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.participant.labels.participants}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.participantsCount}</Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.form.labels.startdate}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.start_date}</Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.form.labels.enddate}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.end_date}</Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.group.categories.local}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>
              {item.collegeObject
                ? item.collegeObject.title
                : I18n.get.misc.notVoCollege}
            </Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>
              {I18n.get.vocertCourseMoment.labels.orderer}
            </Typography>
          </div>
          <div className={classes.right}>
            <Typography>
              {item.ordererObject
                ? item.ordererObject.title
                : I18n.get.misc.notVoCollege}
            </Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.misc.author}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{getUserString(item.author)}</Typography>
          </div>
        </div>
        {item.notes && (
          <div className={classes.row}>
            <div className={classes.left}>
              <Typography>{I18n.get.misc.notes}</Typography>
            </div>
            <div
              className={clsx(
                classes.right,
                classes.notes,
                "vo-global__content",
              )}
            >
              {parse(item.notes)}
            </div>
          </div>
        )}
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.misc.created_at}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.created_at}</Typography>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.left}>
            <Typography>{I18n.get.misc.updated_at}</Typography>
          </div>
          <div className={classes.right}>
            <Typography>{item.updated_at}</Typography>
          </div>
        </div>
      </div>
    </EditDialog>
  );
};

export default CourseMoment;
